import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "tw-inline-flex tw-w-fit tw-shrink-0 tw-items-center tw-justify-center tw-gap-1 tw-overflow-hidden tw-rounded-full tw-border tw-border-transparent tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-whitespace-nowrap tw-transition-colors",
  {
    variants: {
      variant: {
        default: "tw-bg-primary tw-text-black",
        secondary: "tw-bg-surface-secondary tw-text-white",
        destructive: "tw-bg-bad tw-text-white",
        outline: "tw-border-border tw-text-white",
        success: "tw-bg-jade/15 tw-text-jade tw-border-jade/30",
        warning: "tw-bg-gold/15 tw-text-gold tw-border-gold/30",
        error: "tw-bg-bad/15 tw-text-bad tw-border-bad/30",
        info: "tw-bg-primary/15 tw-text-primary-light tw-border-primary/30",
        teal: "tw-bg-primary/15 tw-text-primary tw-border-primary/30",
        new: "tw-bg-gold tw-text-black tw-text-[8px] tw-font-black tw-px-1.5 tw-py-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
});
Badge.displayName = "Badge";

export { Badge, badgeVariants };
